import { Component, h, Prop, State } from '@stencil/core';



@Component({
  tag: 'signet-icon',
  styleUrl: 'signet-icon.scss',
  shadow: false,
})
export class SignetIcon {
  @Prop({ reflect: true }) variant: 'default' | 'sharp' | 'outlined' | 'round' | 'two-tone' = 'default';
  @Prop({ reflect: true }) icon = 'account_circle';
  @State() fontLoaded = false;

  componentDidLoad() {
    if (document.fonts) {
      document.fonts.load('1em "Material Icons"').then(() => {
        this.fontLoaded = true;
      });
    } else {
      this.fontLoaded = true;
    }
  }

  render() {
    let iconClass = 'material-icons mi';
    if (this.variant !== 'default') {
      iconClass += ' material-icons-' + this.variant;
    }
    if (!this.fontLoaded) {
      iconClass += ' icon-loading';
    }
    return <span class={iconClass} aria-hidden={!this.fontLoaded}>{this.icon}</span>;
  }
}
